import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth, apiErr } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Berhasil masuk");
      navigate("/");
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-slate-900">
      <div className="hidden lg:flex flex-col justify-between p-12 bg-slate-900 relative overflow-hidden">
        <div className="absolute inset-0 opacity-20"
          style={{ backgroundImage: "url(https://images.unsplash.com/photo-1504307651254-35680f356dfd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200)", backgroundSize: "cover", backgroundPosition: "center" }} />
        <div className="relative flex items-center gap-3">
          <img src="/logo.png" alt="Coating Solution" className="h-12 w-12 rounded-xl bg-white object-contain p-1" />
          <div>
            <div className="font-heading text-xl font-extrabold text-white">COATING SOLUTION</div>
            <div className="text-xs uppercase tracking-widest text-blue-300">HR Management System</div>
          </div>
        </div>
        <div className="relative">
          <h2 className="font-heading text-4xl font-black text-white leading-tight">
            Kelola gaji harian<br />tim proyek Anda<br />
            <span className="text-blue-400">dengan cepat & akurat.</span>
          </h2>
          <p className="mt-4 max-w-md text-slate-300">
            Absensi, kasbon, lembur, tunjangan, hingga slip gaji — semua dalam satu sistem terintegrasi.
          </p>
        </div>
        <div className="relative text-xs text-slate-500">© 2026 Coating Solution — HR Management System</div>
      </div>

      <div className="flex items-center justify-center p-6 bg-slate-50">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5" data-testid="login-form">
          <div className="lg:hidden flex items-center gap-3 justify-center mb-6">
            <img src="/logo.png" alt="Coating Solution" className="h-12 w-12 rounded-xl bg-white object-contain p-1" />
            <div className="font-heading text-xl font-extrabold text-slate-900">COATING SOLUTION</div>
          </div>
          <div>
            <h1 className="font-heading text-2xl font-bold text-slate-900">Masuk ke akun Anda</h1>
            <p className="text-sm text-slate-500 mt-1">Gunakan email dan kata sandi yang terdaftar.</p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} data-testid="login-email"
              onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Kata Sandi</Label>
            <Input id="password" type="password" value={password} data-testid="login-password"
              onChange={(e) => setPassword(e.target.value)} required />
          </div>
          <Button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full bg-blue-800 hover:bg-blue-900">
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Masuk
          </Button>
          <div className="text-center">
            <Link to="/forgot-password" className="text-sm text-blue-700 hover:underline"
              data-testid="forgot-link">
              Lupa kata sandi?
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
